import type { Node } from '@tiptap/pm/model';

export const getSelectedNodes = ({ editor }: $TSFixMe) => {
  const selection = editor.state.selection;
  const nodes: Node[] = [];
  editor.state.doc.nodesBetween(selection.from, selection.to, (node: Node) => {
    nodes.push(node);
  });

  return nodes;
};
